export default {
  add_products: '+ Añadir productos',
};
